import React from "react";
import { haptic } from "@/lib/design";

// Grand nombre (Big Shoulders 800, 72px) + % qui se met à jour en direct
// pendant que l'utilisateur fait glisser un curseur horizontal.
export const MotivationSlider = ({ value = 50, onChange }) => {
    const pct = Math.max(0, Math.min(100, value));
    const trackStyle = {
        background: `linear-gradient(to right, var(--red) 0%, var(--red) ${pct}%, var(--border) ${pct}%, var(--border) 100%)`,
    };
    return (
        <div className="flex-1 flex flex-col items-center justify-center gap-10">
            <div className="flex items-end justify-center leading-none" data-testid="motivation-value">
                <span
                    className="font-display"
                    style={{ fontSize: "72px", fontWeight: 800, lineHeight: 1, color: "var(--text)" }}
                >
                    {pct}
                </span>
                <span
                    className="font-display"
                    style={{ fontSize: "40px", fontWeight: 800, lineHeight: 1, color: "var(--red)", marginBottom: 6 }}
                >
                    %
                </span>
            </div>
            <input
                type="range"
                min={0}
                max={100}
                step={1}
                value={pct}
                data-testid="motivation-slider"
                className="rv-slider w-full"
                style={trackStyle}
                onChange={(e) => {
                    const v = parseInt(e.target.value, 10);
                    if (v % 10 === 0) haptic();
                    onChange && onChange(v);
                }}
            />
        </div>
    );
};
